import * as React from 'react'

const SvgZoomOut = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M31.04 26.56l-4.48-4.48c1.44-2.24 2.24-4.8 2.24-7.68 0-8-6.4-14.4-14.4-14.4S0 6.4 0 14.4s6.4 14.4 14.4 14.4c2.88 0 5.44-.8 7.68-2.24l4.48 4.48c1.28 1.28 3.2 1.28 4.48 0 1.28-1.28 1.28-3.2 0-4.48zM14.4 25.6c-6.24 0-11.2-4.96-11.2-11.2 0-6.24 4.96-11.2 11.2-11.2 6.24 0 11.2 4.96 11.2 11.2 0 6.24-5.12 11.2-11.2 11.2z"
      fill="currentColor"
    />
    <path
      d="M7.4 14.4c0-.884.627-1.6 1.4-1.6H20c.773 0 1.4.716 1.4 1.6 0 .884-.627 1.6-1.4 1.6H8.8c-.773 0-1.4-.716-1.4-1.6z"
      fill="currentColor"
    />
  </svg>
)

export default SvgZoomOut
